export default [
    {
        path: '/asset/asset-locations',
        name: 'asset-locations',
        props: true,
        component: () => import('@/views/asset/locations/index.vue'),
        meta: {
            pageTitle: 'Asset Locations',
            breadcrumb: [
                {
                text: 'Asset Locations',
                active: true,
                },
            ],
        },
    },
    {
        path: '/asset/asset-locations/add',
        name: 'create-asset-locations',
        component: () => import('@/views/asset/locations/create.vue'),
        meta: {
            pageTitle: 'Create Asset Locations',
            breadcrumb: [
                {
                text: 'Asset Locations',
                to: { name: 'asset-locations' },
                },
                {
                text: 'Create Asset Locations',
                active: true,
                },
            ],
        },
    },
    {
        path: '/asset/asset-locations/:id',
        name: 'detail-asset-locations',
        props: true,
        component: () => import('@/views/asset/locations/detail.vue'),
        meta: {
            pageTitle: 'Detail Asset Locations',
            breadcrumb: [
                {
                text: 'Asset Locations',
                to: { name: 'asset-locations' },
                },
                {
                text: 'Detail Asset Locations',
                active: true,
                },
            ],
        },
    },
]